import { render, staticRenderFns } from "./storeFileDetail.vue?vue&type=template&id=6e18a1b8&scoped=true&"
import script from "./storeFileDetail.vue?vue&type=script&lang=js&"
export * from "./storeFileDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeFileDetail.vue?vue&type=style&index=0&id=6e18a1b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18a1b8",
  null
  
)

export default component.exports